import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/solid/{S,M,L}/injection.svg` */
export const InjectionSolidIcon = createTripletGlyphIcon('InjectionSolidIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.08615 12.4543L5.47873 14.0891C5.51152 14.1116 5.51493 14.1638 5.48654 14.2053L5.1008 14.7698C5.0724 14.8113 5.02234 14.8273 4.98947 14.8049L2.59787 13.1702C2.56505 13.1477 2.56082 13.0955 2.58908 13.054L2.9758 12.4885C3.00417 12.4474 3.05339 12.4323 3.08615 12.4543Z"
        fill="currentColor"
      />
      <path
        d="M5.94748 11.9407L4.95236 13.3948L3.99631 12.7415L4.99045 11.2864L5.94748 11.9407Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43576 4.24829C8.65856 4.03262 9.0097 3.99616 9.2756 4.17798L11.4524 5.66821C11.7183 5.85021 11.811 6.18999 11.6906 6.47583L11.6272 6.59399L7.62814 12.4358L7.58518 12.4866C7.48955 12.5793 7.34655 12.6068 7.22385 12.5549L7.16525 12.5227L4.43771 10.6555C4.28621 10.5515 4.24714 10.3444 4.3508 10.1926L8.34885 4.35083L8.43576 4.24829ZM5.69162 10.1809L7.15451 11.1829L7.50412 10.6702L6.55978 10.0247L7.04904 9.30981L7.99338 9.95435L8.44357 9.2981L7.884 8.91626L8.37326 8.20044L8.93283 8.58228L9.39182 7.91333L8.38596 7.22583L8.87521 6.51099L9.88107 7.19751L10.4748 6.3313L9.01193 5.33032L5.69162 10.1809Z"
        fill="currentColor"
      />
      <path
        d="M11.6262 4.41431L11.1369 5.13013L9.89279 4.27954L10.3821 3.56372L11.6262 4.41431Z"
        fill="currentColor"
      />
      <path
        d="M11.4856 4.02954L10.7922 3.61743L12.5705 1.18481H13.4299L11.4856 4.02954Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.06753 14.0787L5.75796 15.9176C5.79493 15.9429 5.79869 16.0007 5.76675 16.0475L5.33316 16.6832C5.30121 16.73 5.24514 16.7475 5.20816 16.7223L2.51675 14.8834C2.47986 14.8581 2.47602 14.7993 2.50796 14.7526L2.94253 14.1168C2.97455 14.0703 3.03066 14.0535 3.06753 14.0787Z"
        fill="currentColor"
      />
      <path
        d="M6.28531 13.4996L5.16617 15.1364L4.08999 14.401L5.20914 12.7643L6.28531 13.4996Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.98746 4.96252C9.22141 4.62094 9.68771 4.53347 10.0294 4.76721L12.4787 6.44397C12.8203 6.67795 12.9079 7.1442 12.674 7.48596L8.17691 14.0573L8.12808 14.1158C8.00272 14.237 7.80492 14.2572 7.65542 14.1549L4.58707 12.0553C4.43752 11.9529 4.3855 11.761 4.45328 11.6002L4.48941 11.5338L8.98746 4.96252ZM5.80679 11.5573L7.67886 12.8385L8.15054 12.1481L6.97476 11.3453L7.52457 10.5406L8.70035 11.3434L9.20621 10.6051L8.46402 10.0973L9.0148 9.2926L9.75699 9.80042L10.2736 9.04651L9.02945 8.1969L9.57925 7.39124L10.8244 8.24182L11.5695 7.15393L9.69742 5.8717L5.80679 11.5573Z"
        fill="currentColor"
      />
      <path
        d="M12.674 5.03284L12.1242 5.8385L10.7248 4.88147L11.2746 4.07678L12.674 5.03284Z"
        fill="currentColor"
      />
      <path
        d="M12.5158 4.60022L11.7355 4.13733L13.7365 1.40002H14.7033L12.5158 4.60022Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.08952 18.771L7.67741 21.2231C7.72657 21.2569 7.73162 21.3347 7.68913 21.397L7.11002 22.2446C7.06745 22.3069 6.99332 22.3299 6.94401 22.2964L3.35514 19.8442C3.30621 19.8104 3.30091 19.7326 3.34342 19.6704L3.92252 18.8228C3.96516 18.7605 4.04024 18.7373 4.08952 18.771Z"
        fill="currentColor"
      />
      <path
        d="M8.37956 18.0005L6.88834 20.1821L5.45377 19.2017L6.94498 17.019L8.37956 18.0005Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0446 6.53467C12.3716 6.14749 12.9454 6.06367 13.3727 6.35596L16.6393 8.59131L16.7204 8.65381C17.0815 8.95913 17.1792 9.47877 16.9528 9.89404L16.9001 9.98096L10.903 18.7437L10.8366 18.8208C10.6934 18.9591 10.4801 18.9994 10.2965 18.9224L10.2077 18.8735L6.11588 16.0737C5.88811 15.9177 5.83006 15.6063 5.986 15.3784L11.9831 6.61572L12.0446 6.53467ZM7.51041 15.4526L10.2809 17.3491L11.0036 16.2915L9.29948 15.1274L10.0329 14.0532L11.738 15.2183L12.4128 14.2329L11.2858 13.4634L12.0192 12.3901L13.1462 13.1606L13.8346 12.1558L12.0387 10.9292L12.7721 9.85498L14.569 11.0825L15.6569 9.49463L12.8864 7.59814L10.1984 11.5254L7.51041 15.4526Z"
        fill="currentColor"
      />
      <path
        d="M16.8991 6.71045L16.1657 7.78369L14.2995 6.5083L15.0329 5.43506L16.8991 6.71045Z"
        fill="currentColor"
      />
      <path
        d="M16.6872 6.1333L15.6471 5.51611L18.3141 1.8667H19.6042L16.6872 6.1333Z"
        fill="currentColor"
      />
    </svg>
  ),
});
